import { MediaFragment } from '@graphql/generated/graphql';

export const getMediaType = (media: MediaFragment): 'image' | 'video' => {
    return media.mime.split('/')[0] as 'image' | 'video';
};
